export default "__VITE_ASSET__BUQ9sp8s__"